//#region Libraries
import { useState } from "react";
//#endregion
//#region Styles
import { Tooltip } from "components/styles";
import { Container } from "./styles";
//#endregion
//#region Components
//#endregion
//#region Images
import InfoIcon from "icons/InfoIcon";
//#endregion

const DEFAULT_PROPS_FOR_TOOLTIP = {
    x: "-10%", y: "-180%",
    width: "205px",
    height: "unset",
    after: {
        x: "-400%", y: "-10%",
        angle: "45deg"
    }
};

const TooltipButton = ({
    message,
    content,
    tooltipProps,
    className, 
    size = 22
}) => {
    const [classList, setClassList] = useState([]);
    const actions = {
        remove: className => {
            if (!classList.includes(className)) return;
            setClassList(classList.filter(cl => cl !== className));
        },
        add: className => {
            if (classList.includes(className)) return;
            setClassList([...classList, className]);
        },
        get: () => classList.join(" ")
    };
    const getTooltipProps = () => {
        const { x, y, width, height, after } = DEFAULT_PROPS_FOR_TOOLTIP;
        return {
            x: tooltipProps?.x || x, 
            y: tooltipProps?.y || y,
            width: tooltipProps?.width || width,
            height: tooltipProps?.height || height,
            after: {
                x: tooltipProps?.after?.x || after.x,
                y: tooltipProps?.after?.y || after.y,
                angle: tooltipProps?.after?.angle || after.angle
            }
        };
    }
    return (
        <Container 
            className={className}
            onMouseEnter={() => actions.add("active")}
            onMouseLeave={() => actions.remove("active")}>
            <InfoIcon size={size}/>
            <Tooltip
                {...getTooltipProps()}
                className={actions.get()}>
                {content ?? <span title="message">{message}</span>}
            </Tooltip>
        </Container>
    );
}

export default TooltipButton;